
export class Helpers {

    static removeAllFromArray2<T>(item: T, arr: T[], isEqual: (item1: T, item2: T) => boolean): T[] {
        let ret: T[] = [];
        for (let member of arr) {
            if (!isEqual(item, member)) {
                ret.push(member);
            }
        }
        return ret;
    }

    static removeAllFromArray<T>(item: T, arr: T[]): T[] {
        let ret: T[] = [];
        for (let member of arr) {
            if (item != member) {
                ret.push(member);
            }
        }
        return ret;
    }

    static distinct<T>(arr: T[]) {
        let ret = [];
        for (let item of arr) {
            if (ret.indexOf(item) === -1) {
                ret.push(item)
            }
        }
        return ret;
    }

    static sum(arr: number[]) {
        return arr.reduce((partialSum: any, a: any) => partialSum + a, 0);
    }

    static chooseRandom(arr: any[]) {
        if (arr.length === 0) throw new Error("zero length array");
        let index = Math.floor(Math.random() * arr.length);
        return arr[index];
    }

    static randomInt(limit: number) {
        return Math.floor(Math.random() * (limit + 1));
    }

    static difference(arr: any, notArr: any) {
        let ret = [];
        for (let a of arr) {
            if (notArr.indexOf(a) === -1) ret.push(a);
        }
        return ret;
    }

    static replaceAll(within: string, char: string, neww: string) {
        return this.replace(within, char, neww, 0);
    }

    static replace(within: string, char: string, neww: string, i: number): string {
        if (i === within.length) return "";
        if (within[i] === char) {
            return neww + this.replace(within, char, neww, i + 1);
        }
        else {
            return within[i] + this.replace(within, char, neww, i + 1);
        }
    }

    static get<T>(url: string): Promise<T> {
        return fetch(url)
            .then((req: Response) => req.json())
    }

    static post<T>(url: string, data: any): Promise<T> {
        return fetch(url, {
            method: "post", body: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' },
        })
            .then((req: Response) => req.json())
    }

    static put<T>(url: string, data: any): Promise<T> {
        return fetch(url, {
            method: "put", body: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' },
        })
            .then((req: Response) => req.json())
    }

    static delete(url: string): Promise<number> {
        return fetch(url, {
            method: "delete",
            headers: { 'Content-Type': 'application/json' },
        })
            .then((req: Response) => req.json())
    }

    static range(start: number, end: number) {
        let ret = [];
        if (end < start) {
            for (let i = start; i > end; i -= 1) {
                ret.push(i);
            }
        }
        else {
            for (let i = start; i < end; i += 1) {
                ret.push(i);
            }
        }
        return ret;
    }

    static delay(ms: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            setTimeout(resolve, ms);
        });
    }
    
    static pushIfNotExists<T>(item: T, arr: T[]) {
        let exists = arr.indexOf(item) != -1;
        if (!exists) {
            arr.push(item);
        }
    }
}